export default "__VITE_ASSET__BgXMiXNY__"